import React, { useState } from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { PolicyDispatchingStackParamList } from './PolicyDispatchingStackParamList'
import PDStockInScreen from './PDStockInScreen'
import PDStockOutScreen from './PDStockOutScreen'
import PDAuthorizationLetterScreen from './PDAuthorizationLetterScreen'
import PDACKScreen from './PDACKScreen'
import PDContractInformationScreen from './PDContractInformationScreen'
import PDOldContractInformationScreen from './PDOldContractInformationScreen'
import PDAgentContractScreen from './PDAgentContractScreen'
import PDAgentInformationScreen from './PDAgentInformationScreen'
import PDUpdatedLetterScreen from './PDUpdatedLetterScreen'
import PDNotReturnLetterScreen from './PDNotReturnLetterScreen'
import PDAuthorizeLetterScreen from './PDAuthorizeLetterScreen'
import PDCheckLogScreen from './PDCheckLogScreen'
import PDReportScreen from './PDReportScreen'
import PDUploadScreen from './PDUploadScreen'
import PDRDOManagementScreen from './PDRDOManagementScreen'
import PDCreateRdoScreen from './PDCreateRdoScreen'
import PolicyDispatchingLayout from './components/PolicyDispatchingLayout'
import {
  getRememberedOfficeCode,
  PolicyDispatchingOfficeContext,
  rememberOfficeCode
} from './components/PolicyDispatchingOfficeContext'

const Stack = createStackNavigator<PolicyDispatchingStackParamList>()

const withPolicyDispatchingLayout = (Component: React.ComponentType<any>) => {
  return (props: any) => (
    <PolicyDispatchingLayout
      routeName={props.route.name}
      routeParams={props.route.params}
      navigation={props.navigation}
    >
      <Component {...props} />
    </PolicyDispatchingLayout>
  )
}

const PDStockInScreenWithLayout = withPolicyDispatchingLayout(PDStockInScreen)
const PDStockOutScreenWithLayout = withPolicyDispatchingLayout(PDStockOutScreen)
const PDAuthorizationLetterScreenWithLayout = withPolicyDispatchingLayout(PDAuthorizationLetterScreen)
const PDACKScreenWithLayout = withPolicyDispatchingLayout(PDACKScreen)
const PDContractInformationScreenWithLayout = withPolicyDispatchingLayout(PDContractInformationScreen)
const PDOldContractInformationScreenWithLayout = withPolicyDispatchingLayout(PDOldContractInformationScreen)
const PDAgentContractScreenWithLayout = withPolicyDispatchingLayout(PDAgentContractScreen)
const PDAgentInformationScreenWithLayout = withPolicyDispatchingLayout(PDAgentInformationScreen)
const PDUpdatedLetterScreenWithLayout = withPolicyDispatchingLayout(PDUpdatedLetterScreen)
const PDNotReturnLetterScreenWithLayout = withPolicyDispatchingLayout(PDNotReturnLetterScreen)
const PDAuthorizeLetterScreenWithLayout = withPolicyDispatchingLayout(PDAuthorizeLetterScreen)
const PDReportScreenWithLayout = withPolicyDispatchingLayout(PDReportScreen)
const PDCheckLogScreenWithLayout = withPolicyDispatchingLayout(PDCheckLogScreen)
const PDUploadScreenWithLayout = withPolicyDispatchingLayout(PDUploadScreen)
const PDRDOManagementScreenWithLayout = withPolicyDispatchingLayout(PDRDOManagementScreen)
const PDCreateRdoScreenWithLayout = withPolicyDispatchingLayout(PDCreateRdoScreen)

export const PolicyDispatchingStack = () => {
  const [officeCode, setOfficeCodeState] = useState<string | null>(() => getRememberedOfficeCode())
  const setOfficeCode = (nextOfficeCode: string | null) => {
    rememberOfficeCode(nextOfficeCode)
    setOfficeCodeState(nextOfficeCode)
  }

  return (
    <PolicyDispatchingOfficeContext.Provider value={{ officeCode, setOfficeCode }}>
      <Stack.Navigator initialRouteName="PDStockInScreen" screenOptions={{ headerShown: false }}>
        <Stack.Screen name="PDStockInScreen" component={PDStockInScreenWithLayout} />
        <Stack.Screen name="PDStockOutScreen" component={PDStockOutScreenWithLayout} />
        <Stack.Screen name="PDAuthorizationLetterScreen" component={PDAuthorizationLetterScreenWithLayout} />
        <Stack.Screen name="PDACKScreen" component={PDACKScreenWithLayout} />
        <Stack.Screen name="PDContractInformationScreen" component={PDContractInformationScreenWithLayout} />
        <Stack.Screen name="PDOldContractInformationScreen" component={PDOldContractInformationScreenWithLayout} />
        <Stack.Screen name="PDAgentContractScreen" component={PDAgentContractScreenWithLayout} />
        <Stack.Screen name="PDAgentInformationScreen" component={PDAgentInformationScreenWithLayout} />
        <Stack.Screen name="PDUpdatedLetterScreen" component={PDUpdatedLetterScreenWithLayout} />
        <Stack.Screen name="PDNotReturnLetterScreen" component={PDNotReturnLetterScreenWithLayout} />
        <Stack.Screen name="PDAuthorizeLetterScreen" component={PDAuthorizeLetterScreenWithLayout} />
        <Stack.Screen name="PDReportScreen" component={PDReportScreenWithLayout} />
        <Stack.Screen name="PDCheckLogScreen" component={PDCheckLogScreenWithLayout} />
        <Stack.Screen name="PDUploadScreen" component={PDUploadScreenWithLayout} />
        <Stack.Screen name="PDRDOManagementScreen" component={PDRDOManagementScreenWithLayout} />
        <Stack.Screen name="PDCreateRdoScreen" component={PDCreateRdoScreenWithLayout} />
      </Stack.Navigator>
    </PolicyDispatchingOfficeContext.Provider>
  )
}
